import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {enrichNodePath} from '../mappers'
import {PlantNode} from '../types'

export const QueryKey = 'upm-structure'

type Params = {
  plantId: string
  includeEquipment?: boolean
  options?: Omit<UseQueryOptions<PlantNode, AxiosError>, 'queryKey' | 'queryFn'>
}

export const useUpmStructure = ({plantId, includeEquipment = true, options}: Params) => {
  return useQuery<PlantNode, AxiosError>({
    queryKey: [QueryKey, plantId],
    queryFn: async () => {
      const path = `/upm/plants/${plantId}/structure`
      const response = await ApiClient.axiosInstance.get<PlantNode>(path, {
        params: {includeEquipment}
      })
      return response.data
    },
    select: enrichNodePath,
    ...options
  })
}
